
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleTagList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/tag/list${queryString}`
    );
}

export async function consoleTagGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/tag/${item_id}/show`
    );
}

export async function consoleTagCreate(
    console_id: string,
    tag_id: string
) {
    return await clientAxios.post(
        `admin/console/${console_id}/tag/create`,
        { tag_id }
    );
}

export async function consoleTagDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/tag/${item_id}/delete`,
    );
}
